/**
 * Decides whether a Mac project chat must render read-only (history visible,
 * composer blocked).
 *
 * Web cannot control Mac project chats. Native keeps recovery and send controls
 * available unless access was explicitly revoked; those actions verify current
 * access before running. Empty history can mean a launch failed before its first
 * message, or that history is still loading, rather than a disconnected Mac.
 */
export function resolveMacProjectReadOnly({
  platform,
  isMacProjectChat,
  revokedAt,
} = {}) {
  if (!isMacProjectChat) return false;
  if (platform === 'web') return true;

  return !!revokedAt;
}

export default resolveMacProjectReadOnly;
